import { Component, Inject } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { ProductType } from "src/app/core/enums";
import { ModalWindow } from "src/app/core/modal-window";

@Component({
  selector: "app-confirm",
  templateUrl: "./choice.component.html",
  standalone: false,
})
export class ChoiceComponent<T extends object> extends ModalWindow {
  message = "";
  options: T[];
  choice: T;
  canClose: boolean;
  radio = false;

  constructor(
    public dialogRef: MatDialogRef<ChoiceComponent<T>>,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      options: T[];
      message: string;
      canClose: boolean;
      radio: boolean;
    },
  ) {
    super();
    this.message = data.message;
    this.options = data.options;
    this.canClose = data.canClose;
    this.radio = data.radio || false;
  }

  getDisplayValue(value: any): string {
    if (this.isProductType(value)) return this.getProductName(value);
    return typeof value === "string" ? value : String(value);
  }

  isProductType(value: any): boolean {
    return Object.values(ProductType).includes(value);
  }

  getProductName(s: ProductType): string {
    switch (s) {
      case ProductType.ABMR:
        return "ABMR";
      case ProductType.CBMR:
        return "CBMR";
      case ProductType.CLONEMANAGER:
        return "CloneManager Online";
      case ProductType.CMLITE:
        return "CloneManager Offline";
      case ProductType.COBMR:
        return "CoBMR";
      case ProductType.NBMR:
        return "NBMR";
      case ProductType.PBMR:
        return "PBMR";
      case ProductType.RBMR:
        return "RBMR";
      case ProductType.TBMR:
        return "TBMR";
      case ProductType.VA:
        return "Virtual Appliance";
      default:
        return "Unknown";
    }
  }

  handleClose() {
    if (!this.choice && !this.canClose) return;
    super.closeModalAndReturnOutput(null);
  }

  confirm() {
    if (!this.choice && !this.canClose) return;
    super.closeModalAndReturnOutput(this.choice);
  }
}
